import { render, staticRenderFns } from "./municipios.vue?vue&type=template&id=59456262&scoped=true"
import script from "./municipios.vue?vue&type=script&lang=js"
export * from "./municipios.vue?vue&type=script&lang=js"
import style0 from "./municipios.vue?vue&type=style&index=0&id=59456262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59456262",
  null
  
)

export default component.exports